'use client';

import dynamic from 'next/dynamic';

export const ServiceLayer = dynamic(() => import('./ServiceLayerComponents'), {
  ssr: false,
  loading: () => <div>Loading...</div>,
});
